import React from "react";
import AsyncSelect from "react-select/lib/Async";
const refreshIcon = require("assets/img/icons/refresh.png");

// Filtro por padre PT, igual en las dos pestañas de miga de desecho
export const FiltroPadrePT = ({ hook }) => (
    <div className="formulario-fields-row mt-0 align-items-end justify-content-start">
        <div
            className="formulario-field"
            style={{ minWidth: "220px", maxWidth: "220px" }}
        >
            <label className="text-nowrap">Padre PT</label>
            <AsyncSelect
                className="react-select-container"
                isSearchable
                isClearable
                cacheOptions
                defaultOptions
                loadOptions={hook.loadPadresProductoTerminado}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.nombre}
                placeholder="Todos"
                value={hook.padreProductoTerminadoFiltro}
                onChange={hook.setPadreProductoTerminadoFiltro}
            />
        </div>

        <img
            src={refreshIcon}
            alt="Refrescar listado"
            title="Refrescar listado"
            className="action_img mb-1"
            onClick={hook.Refrescar}
        />
    </div>
);
